import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  TextField, 
  Button, 
  Typography, 
  Box,
  Paper,
  CircularProgress,
  FormHelperText,
  InputAdornment,
  IconButton,
  Checkbox,
  FormControlLabel,
  Grid,
  Avatar,
  Switch,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import { apiService } from '../../utils/api';
import { sendVerificationEmail } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';
import config from '../../config';
import axios from 'axios';

const ViewerRegistrationForm = () => {
  const { currentUser, setCurrentUser, setUserRole, register: authRegister } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [error, setError] = useState('');
  const [showPhoneInfo, setShowPhoneInfo] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [useAutoPassword, setUseAutoPassword] = useState(false);
  const [usernameAvailable, setUsernameAvailable] = useState(true);
  const [isCheckingUsername, setIsCheckingUsername] = useState(false);
  const [phoneAvailable, setPhoneAvailable] = useState(true);
  const [isCheckingPhone, setIsCheckingPhone] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [passwordCopied, setPasswordCopied] = useState(false);
  const [prefectures, setPrefectures] = useState([]);
  const [ageError, setAgeError] = useState('');
  
  // 入力フォーム状態
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    phone_number: '',
    birth_date: '',
    gender: '',
    prefecture_code: ''
  });

  // 初期データ読み込み
  useEffect(() => {
    // 都道府県データの取得
    const fetchPrefectures = async () => {
      try {
        console.log('都道府県データ取得開始');
        // APIサービスの詳細情報をログ出力
        console.log('apiServiceの状態:', apiService.defaults?.baseURL, apiService.defaults?.headers);
        console.dir(apiService);
        
        const url = '/api/areas/prefectures';
        console.log('都道府県リクエストURL:', url);
        console.log('API BASE URL:', config.API_BASE_URL);
        
        // まずapiServiceで試す
        try {
          const response = await apiService.get(url);
          console.log('都道府県データ取得成功:', response.data);
          
          if (Array.isArray(response.data)) {
            setPrefectures(response.data);
          } else if (response.data?.data && Array.isArray(response.data.data)) {
            setPrefectures(response.data.data);
          } else if (response.data?.prefectures && Array.isArray(response.data.prefectures)) {
            setPrefectures(response.data.prefectures);
          } else if (response.data?.results && Array.isArray(response.data.results)) {
            setPrefectures(response.data.results);
          } else {
            // APIサービスでの取得に失敗した場合、直接axiosでも試す
            throw new Error('apiServiceでの取得に失敗');
          }
        } catch (apiError) {
          console.error('apiServiceでのリクエスト失敗。直接axiosで試します:', apiError);
          
          // 直接axiosでリクエスト
          try {
            const fullUrl = `${config.API_BASE_URL}${url}`;
            console.log('axios直接リクエストURL:', fullUrl);
            const fallbackResponse = await axios.get(fullUrl);
            console.log('axios直接呼び出しの結果:', fallbackResponse.data);
            
            if (Array.isArray(fallbackResponse.data)) {
              setPrefectures(fallbackResponse.data);
            } else if (fallbackResponse.data?.data && Array.isArray(fallbackResponse.data.data)) {
              setPrefectures(fallbackResponse.data.data);
            } else if (fallbackResponse.data?.prefectures && Array.isArray(fallbackResponse.data.prefectures)) {
              setPrefectures(fallbackResponse.data.prefectures);
            } else if (fallbackResponse.data?.results && Array.isArray(fallbackResponse.data.results)) {
              setPrefectures(fallbackResponse.data.results);
            } else {
              console.error('有効な都道府県データが得られませんでした', fallbackResponse.data);
              console.error('レスポンスの型:', typeof fallbackResponse.data, 'レスポンスのキー:', Object.keys(fallbackResponse.data || {}));
              
              // どちらの方法でも失敗した場合はデフォルトデータを使用
              console.log('デフォルトの都道府県データを使用します');
              setPrefectures(getDefaultPrefectures());
            }
          } catch (axiosError) {
            console.error('axios直接リクエストエラー:', axiosError);
            console.log('デフォルトの都道府県データを使用します');
            setPrefectures(getDefaultPrefectures());
          }
        }
      } catch (error) {
        console.error('都道府県データ取得エラー:', error);
        console.error('エラー詳細:', error.response?.data || error.message);
        setError('都道府県データの取得に失敗しました。ネットワーク接続を確認してください。');
        
        // エラーの種類に関わらずデフォルト都道府県を使用
        setPrefectures(getDefaultPrefectures());
      }
    };
    
    // ユーザーデータを取得
    const fetchUserData = async () => {
      if (!currentUser) return;
    
        try {
          const response = await apiService.get(`/api/users/profile/${currentUser.id}`);
          const userData = response.data;
          
          if (userData.viewer_profile) {
            setFormData(prev => ({
              ...prev,
              phone_number: userData.viewer_profile.phone_number || '',
              birth_date: userData.viewer_profile.birth_date || '',
              gender: userData.viewer_profile.gender || '',
              prefecture_code: userData.prefecture_code || ''
            }));
          }
        } catch (error) {
        console.error('ユーザーデータ取得エラー:', error);
          setError('ユーザーデータの取得に失敗しました');
        }
      };
      
    // データ取得実行
    fetchPrefectures();
      fetchUserData();
  }, [currentUser]);
  
  // 入力値の変更を処理
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // ユーザー名のフィールドが変更された場合、利用可能性チェックをリセット
    if (name === 'username' && value.length >= 3) {
      checkUsernameAvailability(value);
    }

    // 生年月日が変更された場合、年齢チェックを実行
    if (name === 'birth_date') {
      if (value) {
        validateAge(value);
      } else {
        // 生年月日が空の場合はエラーをクリア
        setAgeError('');
      }
    }
  };

  // ユーザー名の利用可能性をチェック
  const checkUsernameAvailability = async (username) => {
    if (username.length < 3) return;
    
    setIsCheckingUsername(true);
    setError('');
    
    try {
      const response = await apiService.get(`/api/auth/check-username?username=${username}`);
      
      if (response.data && typeof response.data === 'object') {
        if ('available' in response.data) {
      setUsernameAvailable(response.data.available);
        } else if ('exists' in response.data) {
          setUsernameAvailable(!response.data.exists);
        } else {
          console.error('ユーザー名チェックの応答形式が不正:', response.data);
          setUsernameAvailable(false);
          setError('ユーザー名の確認ができませんでした。別のユーザー名を試すか、後でもう一度お試しください。');
        }
      } else {
        console.error('予期しない応答:', response.data);
        setUsernameAvailable(false);
        setError('ユーザー名の確認ができませんでした。別のユーザー名を試すか、後でもう一度お試しください。');
      }
    } catch (error) {
      console.error('ユーザー名チェックエラー:', error);
      setUsernameAvailable(false);
      setError('ユーザー名の確認中にエラーが発生しました。ネットワーク接続を確認してください。');
    } finally {
      setIsCheckingUsername(false);
    }
  };
  
  // 電話番号の入力処理
  const handlePhoneChange = (e) => {
    // 数字とハイフンのみ許可するバリデーション
    const { value } = e.target;
    if (value === '' || /^[0-9\-]*$/.test(value)) {
      setFormData(prev => ({
        ...prev,
        phone_number: value
      }));

      // 電話番号のフォーマットが正しければ、利用可能性をチェック
      const digitsOnly = value.replace(/-/g, '');
      if (digitsOnly.length >= 10 && digitsOnly.length <= 11) {
        checkPhoneAvailability(value);
      }
    }
  };
  
  // 電話番号の利用可能性をチェック
  const checkPhoneAvailability = async (phoneNumber) => {
    if (!phoneNumber) return;
    
    const digitsOnly = phoneNumber.replace(/-/g, '');
    if (digitsOnly.length < 10 || digitsOnly.length > 11) return;
    
    setIsCheckingPhone(true);
    setError('');
    
    try {
      const response = await apiService.get(`/api/auth/check-phone?phone_number=${phoneNumber}`);
      
      if (response.data && typeof response.data === 'object') {
        if ('available' in response.data) {
      setPhoneAvailable(response.data.available);
        } else if ('exists' in response.data) {
          setPhoneAvailable(!response.data.exists);
        } else {
          console.error('電話番号チェックの応答形式が不正:', response.data);
          setPhoneAvailable(false);
          setError('電話番号の確認ができませんでした。別の電話番号を試すか、後でもう一度お試しください。');
        }
      } else {
        console.error('予期しない応答:', response.data);
        setPhoneAvailable(false);
        setError('電話番号の確認ができませんでした。別の電話番号を試すか、後でもう一度お試しください。');
      }
    } catch (error) {
      console.error('電話番号チェックエラー:', error);
      setPhoneAvailable(false);
      setError('電話番号の確認中にエラーが発生しました。ネットワーク接続を確認してください。');
    } finally {
      setIsCheckingPhone(false);
    }
  };
  
  // 電話番号のフォーマット検証
  const validatePhoneNumber = () => {
    // ハイフンを除去して桁数をチェック
    const digitsOnly = formData.phone_number.replace(/-/g, '');
    return digitsOnly.length >= 10 && digitsOnly.length <= 11 && phoneAvailable;
  };

  // メールアドレス検証
  const validateEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(formData.email);
  };

  // パスワード検証（自動生成でない場合）
  const validatePassword = () => {
    return useAutoPassword || formData.password.length >= 8;
  };

  // ユーザー名検証
  const validateUsername = () => {
    return formData.username.length >= 3 && usernameAvailable;
  };
  
  // 自動パスワード生成
  const generatePassword = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()-_=+';
    let password = '';
    for (let i = 0; i < 12; i++) {
      password += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setFormData(prev => ({
      ...prev,
      password
    }));
    return password;
  };

  // 自動パスワード設定の切り替え
  const handleAutoPasswordToggle = () => {
    const newState = !useAutoPassword;
    setUseAutoPassword(newState);
    setPasswordCopied(false);
    if (newState) {
      // 自動生成時はパスワードが見えるように表示をオンにする
      setShowPassword(true);
      generatePassword();
    } else {
      setShowPassword(false);
    }
  };
  
  // パスワード表示の切り替え
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  // パスワードをクリップボードにコピー
  const handleCopyPassword = async () => {
    if (!formData.password) return;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(formData.password);
      } else {
        // クリップボードAPIが使えない環境向けのフォールバック
        const textArea = document.createElement('textarea');
        textArea.value = formData.password;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setPasswordCopied(true);
      setTimeout(() => setPasswordCopied(false), 2000);
    } catch (err) {
      console.error('パスワードのコピーに失敗しました:', err);
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  
  // フォームの送信
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // バリデーション
    if (!validateUsername() || !validateEmail() || !validatePhoneNumber() || !validatePassword()) {
      setError('入力内容に誤りがあります。確認してください。');
      return;
    }

    // 年齢チェック
    if (!formData.birth_date) {
      setError('生年月日を入力してください。');
      return;
    }

    if (!validateAge(formData.birth_date)) {
      setError(ageError || '18歳未満の方は登録できません。');
      return;
    }

    // 都道府県データの確認
    console.log('都道府県データ確認:', {
      prefectures_count: prefectures.length,
      selected_prefecture: formData.prefecture_code,
      selected_prefecture_name: prefectures.find(p => p.code === formData.prefecture_code)?.name || '不明'
    });

    if (!formData.prefecture_code) {
      setError('都道府県を選択してください。');
      return;
    }

    // 選択された都道府県が一覧に存在するかチェック
    const selectedPrefecture = prefectures.find(p => p.code === formData.prefecture_code);
    if (!selectedPrefecture) {
      setError(`選択された都道府県コード「${formData.prefecture_code}」が見つかりません。`);
      console.error('都道府県コードが無効:', formData.prefecture_code);
      console.error('利用可能な都道府県:', prefectures);
      return;
    }
    
    if (!usernameAvailable) {
      setError('ユーザー名が利用できません。別のユーザー名を選択してください。');
      return;
    }
    
    if (!phoneAvailable) {
      setError('電話番号が既に使用されています。別の電話番号を入力してください。');
      return;
    }

    setLoading(true);
    setError('');
    
    try {
      // FormDataオブジェクトを作成
      const sendData = new FormData();
      sendData.append('username', formData.username);
      sendData.append('email', formData.email);
      sendData.append('password', formData.password);
      sendData.append('phone_number', formData.phone_number);
      sendData.append('birth_date', formData.birth_date);
      sendData.append('gender', formData.gender);
      sendData.append('prefecture_code', formData.prefecture_code);
      
      // AuthContextの登録関数を呼び出してログイン状態を設定
      const registerResult = await authRegister(sendData);
      
      console.log('登録結果:', registerResult);
      console.log('登録結果の型:', typeof registerResult);
      console.log('success プロパティ:', registerResult?.success);
      console.log('user プロパティ:', registerResult?.user);
      console.log('message プロパティ:', registerResult?.message);
      console.log('access_token プロパティ:', registerResult?.access_token);
      
      // 成功判定を修正 - successがtrueまたはmessageとaccess_tokenが存在する場合
      const isSuccess = registerResult && (
        registerResult.success === true || 
        (registerResult.message && registerResult.access_token) ||
        (registerResult.message && registerResult.message.includes('登録が完了'))
      );
      
      if (isSuccess) {
        console.log('登録成功。メール確認を必須とするため自動ログインは行いません');
        // 成功状態にしてフォームを隠し、処理中のローディングを継続表示する
        // （ユーザー名の重複チェック等の残留メッセージを見せないため）
        setSuccess(true);
        setError('');

        // 確認メールを送信（Firebase が独自ドメイン設定に従って送信）
        let mailSent = false;
        if (formData.email && formData.password) {
          try {
            await sendVerificationEmail(formData.email, formData.password);
            mailSent = true;
          } catch (mailErr) {
            console.warn('確認メール送信に失敗しました:', mailErr?.code || mailErr?.message);
          }
        }

        // 閲覧ユーザーはメール確認完了までログイン不可のため、
        // 登録レスポンスで設定された自動ログイン状態を解除する
        try {
          localStorage.removeItem('authToken');
          localStorage.removeItem('refreshToken');
          localStorage.removeItem('user');
          sessionStorage.clear();
        } catch (e) {
          // クリア失敗は致命的ではない
        }

        // ログイン画面で表示する案内をsessionStorageに保存（クリア後に設定すること）
        try {
          sessionStorage.setItem(
            'post_register_message',
            mailSent
              ? '登録が完了しました。確認メールを送信しました。メール内のリンクから認証を完了すると、ログインできるようになります。'
              : '登録が完了しました。ログイン画面から確認メールの再送を行い、メール認証を完了してください。'
          );
        } catch (e) {
          // 保存失敗は致命的ではない
        }

        // フォームをリセット
        setFormData({
          username: '',
          email: '',
          password: '',
          phone_number: '',
          birth_date: '',
          gender: '',
          prefecture_code: ''
        });

        // 即座にログイン画面へ遷移（案内は sessionStorage 経由でログイン画面に表示）
        navigate('/login', { replace: true });
        return;
      } else {
        console.error('登録失敗:', registerResult?.error || '原因不明');
        console.error('完全な登録結果:', registerResult);
        
        // エラーメッセージを設定
        const errorMessage = registerResult?.error || '登録に失敗しました';
        setError(errorMessage);
        setSuccess(false);
      }
    } catch (error) {
      console.error('登録エラー:', error);
      
      // APIエラーレスポンスからエラーメッセージを取得
      let errorMessage = '登録に失敗しました';
      
      if (error.response?.data?.error) {
        errorMessage = error.response.data.error;
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      setError(errorMessage);
      setSuccess(false);
    } finally {
      setLoading(false);
    }
  };

  // デフォルトの都道府県データ
  const getDefaultPrefectures = () => {
    return [
      { code: '01', name: '北海道' },
      { code: '02', name: '青森県' },
      { code: '03', name: '岩手県' },
      { code: '04', name: '宮城県' },
      { code: '05', name: '秋田県' },
      { code: '06', name: '山形県' },
      { code: '07', name: '福島県' },
      { code: '08', name: '茨城県' },
      { code: '09', name: '栃木県' },
      { code: '10', name: '群馬県' },
      { code: '11', name: '埼玉県' },
      { code: '12', name: '千葉県' },
      { code: '13', name: '東京都' },
      { code: '14', name: '神奈川県' },
      { code: '15', name: '新潟県' },
      { code: '16', name: '富山県' },
      { code: '17', name: '石川県' },
      { code: '18', name: '福井県' },
      { code: '19', name: '山梨県' },
      { code: '20', name: '長野県' },
      { code: '21', name: '岐阜県' },
      { code: '22', name: '静岡県' },
      { code: '23', name: '愛知県' },
      { code: '24', name: '三重県' },
      { code: '25', name: '滋賀県' },
      { code: '26', name: '京都府' },
      { code: '27', name: '大阪府' },
      { code: '28', name: '兵庫県' },
      { code: '29', name: '奈良県' },
      { code: '30', name: '和歌山県' },
      { code: '31', name: '鳥取県' },
      { code: '32', name: '島根県' },
      { code: '33', name: '岡山県' },
      { code: '34', name: '広島県' },
      { code: '35', name: '山口県' },
      { code: '36', name: '徳島県' },
      { code: '37', name: '香川県' },
      { code: '38', name: '愛媛県' },
      { code: '39', name: '高知県' },
      { code: '40', name: '福岡県' },
      { code: '41', name: '佐賀県' },
      { code: '42', name: '長崎県' },
      { code: '43', name: '熊本県' },
      { code: '44', name: '大分県' },
      { code: '45', name: '宮崎県' },
      { code: '46', name: '鹿児島県' },
      { code: '47', name: '沖縄県' }
    ];
  };

  // 年齢バリデーション関数
  const validateAge = (birthDate) => {
    if (!birthDate) return true;
    
    try {
      const birth = new Date(birthDate);
      const today = new Date();
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();
      
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      
      const isValid = age >= 18;
      setAgeError(isValid ? '' : '18歳未満の方は登録できません');
      return isValid;
    } catch (error) {
      setAgeError('有効な生年月日を入力してください');
      return false;
    }
  };
  
  return (
    <Paper elevation={3} sx={{ p: 3, mt: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h5" component="h2" gutterBottom>
        閲覧ユーザー登録
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      {success && (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress size={28} sx={{ mb: 2 }} />
          <Alert severity="success" sx={{ mb: 0 }}>
            {successMessage || '登録が完了しました。ログイン画面へ移動します...'}
          </Alert>
        </Box>
      )}

      {!success && loading && (
        <Box sx={{ textAlign: 'center', py: 3 }}>
          <CircularProgress size={32} sx={{ mb: 2 }} />
          <Typography variant="body1">登録処理中です。しばらくお待ちください...</Typography>
        </Box>
      )}

      {!success && !loading && (
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* ユーザー名 */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="ユーザー名 (必須)"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              helperText={
                formData.username 
                  ? isCheckingUsername 
                    ? 'ユーザー名をチェック中...' 
                    : usernameAvailable 
                      ? '使用可能なユーザー名です' 
                      : 'このユーザー名は使用できません'
                  : '3文字以上のユーザー名を入力してください'
              }
              error={formData.username !== '' && (!usernameAvailable || formData.username.length < 3)}
            />
          </Grid>

          {/* メールアドレス */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="メールアドレス (必須)"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
              helperText="有効なメールアドレスを入力してください"
              error={formData.email !== '' && !validateEmail()}
            />
          </Grid>
          
          {/* 電話番号 */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="電話番号 (必須)"
              name="phone_number"
              value={formData.phone_number}
              onChange={handlePhoneChange}
              required
              placeholder="例: 090-1234-5678"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="電話番号の説明"
                      onClick={() => setShowPhoneInfo(!showPhoneInfo)}
                      edge="end"
                    >
                      <InfoIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
              error={formData.phone_number !== '' && !validatePhoneNumber()}
              helperText={
                formData.phone_number
                  ? isCheckingPhone
                    ? '電話番号をチェック中...'
                    : (formData.phone_number.replace(/-/g, '').length < 10 || formData.phone_number.replace(/-/g, '').length > 11)
                      ? '有効な電話番号を入力してください（10〜11桁）'
                      : phoneAvailable
                        ? '使用可能な電話番号です'
                        : 'この電話番号は既に使用されています'
                  : 'ハイフンありでも、なしでも入力可能です'
              }
            />
          </Grid>

          {showPhoneInfo && (
            <Grid item xs={12}>
              <Box sx={{ p: 1, bgcolor: 'info.light', borderRadius: 1 }}>
                <Typography variant="body2">
                  ・電話番号は管理者と企業ユーザーのみ確認できます<br />
                  ・予約機能の利用時に、予約対象の店舗へ電話番号を連絡します<br />
                  ・サービスの不正利用やトラブル時に本人確認として使用される場合があります<br />
                  ・SMS認証などにも使用する予定です
                </Typography>
              </Box>
            </Grid>
          )}

          {/* 生年月日 */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="生年月日 (必須)"
              name="birth_date"
              type="date"
              value={formData.birth_date}
              onChange={handleChange}
              required
              InputLabelProps={{
                shrink: true,
              }}
              error={!!ageError}
              helperText={ageError || "一般公開されません。後から変更することはできません。"}
            />
          </Grid>

          {/* 性別 */}
          <Grid item xs={12}>
            <FormControl component="fieldset" required>
              <FormLabel component="legend">性別 (必須)</FormLabel>
              <RadioGroup
                row
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <FormControlLabel value="male" control={<Radio />} label="男性" />
                <FormControlLabel value="female" control={<Radio />} label="女性" />
                <FormControlLabel value="other" control={<Radio />} label="その他" />
              </RadioGroup>
              <FormHelperText>後から変更することはできません。</FormHelperText>
            </FormControl>
          </Grid>
          
          {/* 都道府県 */}
          <Grid item xs={12}>
            <FormControl fullWidth required>
              <InputLabel id="prefecture-label">都道府県 (必須)</InputLabel>
              <Select
                labelId="prefecture-label"
                id="prefecture_code"
                name="prefecture_code"
                value={formData.prefecture_code}
                label="都道府県 (必須)"
                onChange={handleChange}
              >
                {prefectures.length > 0 ? (
                  prefectures.map((pref) => (
                    <MenuItem key={pref.code} value={pref.code}>
                      {pref.name}
                    </MenuItem>
                  ))
                ) : (
                  // データ取得中または読み込みエラーの場合、デフォルト都道府県を表示
                  getDefaultPrefectures().map((pref) => (
                  <MenuItem key={pref.code} value={pref.code}>
                    {pref.name}
                  </MenuItem>
                  ))
                )}
              </Select>
              <FormHelperText>統計情報に利用されます。後から変更可能です。</FormHelperText>
            </FormControl>
          </Grid>
          
          {/* パスワード自動生成スイッチ */}
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={useAutoPassword}
                    onChange={handleAutoPasswordToggle}
                    color="primary"
                  />
                }
                label="パスワードを自動生成する"
              />
            </Box>
          </Grid>
          
          {/* パスワード入力 */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="パスワード (必須)"
              name="password"
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={handleChange}
              required
              InputProps={{
                // 自動生成時は手入力を防ぐため読み取り専用にする（コピーや表示は可能）
                readOnly: useAutoPassword,
                endAdornment: (
                  <InputAdornment position="end">
                    {useAutoPassword && (
                      <IconButton
                        aria-label="パスワードをコピー"
                        onClick={handleCopyPassword}
                        edge="end"
                        color={passwordCopied ? 'success' : 'default'}
                      >
                        {passwordCopied ? <CheckIcon /> : <ContentCopyIcon />}
                      </IconButton>
                    )}
                    <IconButton
                      aria-label="パスワードの表示切替"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              helperText={useAutoPassword ? '自動生成されたパスワードが設定されています' : '8文字以上のパスワードを設定してください'}
              error={!useAutoPassword && formData.password !== '' && formData.password.length < 8}
            />
          </Grid>

          {/* 自動生成パスワードの保存案内 */}
          {useAutoPassword && formData.password && (
            <Grid item xs={12}>
              <Alert
                severity="warning"
                icon={<InfoIcon />}
                action={
                  <Button
                    color="inherit"
                    size="small"
                    startIcon={passwordCopied ? <CheckIcon /> : <ContentCopyIcon />}
                    onClick={handleCopyPassword}
                  >
                    {passwordCopied ? 'コピーしました' : 'コピー'}
                  </Button>
                }
              >
                このパスワードは登録後に再表示できません。<strong>パスワードは大切に保存しておいてください。</strong>
              </Alert>
            </Grid>
          )}
          
          {/* 利用規約同意 */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.target.checked)}
                  color="primary"
                />
              }
              label="利用規約およびプライバシーポリシーに同意します"
            />
          </Grid>
          
          {/* 送信ボタン */}
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading || !formData.username || !formData.email || !formData.phone_number || 
                        (!useAutoPassword && !formData.password) || !agreeTerms || !formData.birth_date || 
                        !formData.gender || !formData.prefecture_code}
              fullWidth
              sx={{ py: 1.5 }}
            >
              {loading ? <CircularProgress size={24} /> : '登録する'}
            </Button>
          </Grid>
        </Grid>
      </form>
      )}
    </Paper>
  );
};

export default ViewerRegistrationForm; 